<template>
  <div>
    <v-card class="white" flat>
      <v-card-text>

        <v-form v-model="valid">

          <v-row class="ml-2 mr-2">
            <v-col cols="12" class="tabsNh">

              <template v-if="business">
                <v-col cols="12" style="display: flex; justify-content: end;">
                  <!-- <v-btn small color="error" @click.prevent="confirmDelete">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn> -->
                  <v-btn small class=" btn-save" @click.prevent="updateBusiness">
                    <v-icon>
                      mdi-content-save
                    </v-icon>
                  </v-btn>
                </v-col>
              </template>
              <v-col cols="12" v-else style="display: flex; justify-content: flex-end;">
                <v-btn small @click.prevent="addBusiness" class=" btn-save">
                  <v-icon>
                    mdi-content-save
                  </v-icon>
                </v-btn>
              </v-col>

            </v-col>

          </v-row>
          <v-row class="ml-2 mr-2" style="margin-top: 2rem;  margin-bottom: 1rem;">
            <v-col cols="12" md="2">

              <div class="box">
                <div style="display: flex; justify-content: center; width: 80%;margin-left: 10%;">
                  <v-img :src="url" class="preview-avatar" style="width: 80%; margin-left: 5%; "></v-img>
                </div>
                <v-file-input @change="Preview_image" v-model="image" label="Logo del negocio" prepend-icon="mdi-camera"
                  placeholder="Seleccionar una imágen" :rules="[maxFileSize]">
                </v-file-input>
              </div>
              <div class="box">
                <v-select outlined dense attach v-if="RoleUser == 'ROLE_ROOT'" :items="businessTypes" item-text="name"
                  item-value="value" label="Tipo de negocio *" v-model="form.type" required
                  :rules="requiredRule"></v-select>
              </div>

            </v-col>

            <v-col cols="12" md="10">
              <v-row>
                <v-col cols="12" sm="12" md="12" class="pb-3" style="margin-top: 1rem;">
                  <h3>Datos Principales</h3>
                </v-col>
                <v-col v-if="!business" cols="12" sm="12" md="12">
                  <label>Nota: los apartados con (*) son datos requeridos</label>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field outlined dense v-model="form.name" label="Nombre del negocio *"
                    placeholder="Escriba el nombre del negocio" required></v-text-field>
                </v-col>

                <v-col cols="12" md="3">
                  <v-text-field outlined dense v-model="form.phone" label="Télefono del negocio*" required @input="maskNum"
                    :rules="requiredRule" placeholder="Escriba el télefono del negocio"></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field outlined dense v-model="form.cellphone" label="Celular del negocio*" required @input="maskNum"
                    :rules="requiredRule" placeholder="Escriba el télefono celular del negocio"></v-text-field>
                </v-col>

                <v-col cols="12" md="3">
                  <v-text-field outlined dense v-model="form.email" label="Correo eléctronico del negocio*" required
                    :rules="requiredRule" placeholder="Escriba el correo eléctronico del negocio"></v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field outlined dense v-model="form.whatsapp" label="Whatsapp del negocio" @input="maskNum"
                    placeholder="Escriba whatsapp del negocio"></v-text-field>
                </v-col>


                <v-col cols="12" md="3">
                  <v-text-field outlined dense v-model="form.website" label="Sitio web del negocio"
                    placeholder="Escriba el sitio web del negocio"></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field outlined dense v-model="form.address" label="Dirección del negocio *"
                    placeholder="Escriba la dirección del negocio" required :rules="requiredRule"></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-autocomplete outlined dense :items="getcurrency" label="Moneda*" attach v-model="form.currency"
                    item-text="name" item-value="value" required :rules="requiredRule"></v-autocomplete>
                </v-col>

                <v-col cols="12" md="12" class="pb-3" style="margin-top: .6rem;">
                  <h3>Información de facturación</h3>

                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field outlined dense v-model="form.billingplan" label="Plan del negocio*"
                    placeholder="Escriba el plan de facturación del negocio" required
                    :rules="requiredRule"></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field outlined dense v-model="form.billingname" label="Nombre del negocio*"
                    placeholder="Escriba el nombre de facturación del negocio" required
                    :rules="requiredRule"></v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field outlined dense v-model="form.billingnrc" label="NRC del negocio"
                    placeholder="Escriba el NRC de facturación del negocio*" @keyup="maskNRC"></v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field outlined dense v-model="form.billingnit" label="NIT del negocio*"
                    placeholder="Escriba el NIT de facturación del negocio" required :rules="requiredRule"
                    @keyup="maskNit"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field outlined dense v-model="form.billingaddress" label="Dirección del negocio*" required
                    :rules="requiredRule"></v-text-field>
                </v-col>


                <v-col cols="12" md="6">
                  <v-autocomplete outlined dense :items="activities" item-text="Valores" required :rules="requiredRule"
                    item-value="Codigo" v-model="form.codactividad" label="Descripción de la actividad económica*"
                    attach></v-autocomplete>
                </v-col>
                <v-col cols="12" md="3">
                  <v-autocomplete outlined dense :items="countryList" attach
                    @change="onCountryChange"
                    item-text="name" v-model="form.country" required :rules="requiredRule" label="Pais*"></v-autocomplete>
                </v-col>
                <v-col cols="12" md="3">
                  <v-autocomplete outlined dense :items="departments" v-if="checkcountry" attach item-text="Valores"
                    item-value="Codigo" v-model="form.branchdepartment" label="Estado/Departamento" clearable clear-icon="mdi-close"
                    @change="onSalvadorDepartmentChange(form, 'country', 'branchdepartment', 'branchmunicipality', 'branchdistrict')"></v-autocomplete>
                  <v-autocomplete outlined dense attach v-else :items="stateList" item-text="name"
                    v-model="form.branchdepartment" @change="getCities" label="Estado/Departamento" clearable clear-icon="mdi-close">
                    <template v-slot:no-data>
                      <div class="px-4">{{ noDataLabelStates }}</div>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete outlined dense :items="municipalities" v-if="checkcountry" attach item-text="Valores"
                    item-value="Codigo" :readonly="!form.branchdepartment" v-model="form.branchmunicipality"
                    label="Ciudad" clearable clear-icon="mdi-close"
                    @change="onSalvadorMunicipalityChange(form, 'country', 'branchmunicipality', 'branchdistrict')"></v-autocomplete>
                  <v-autocomplete outlined dense v-else item-text="name" :items="cityList" attach
                    :readonly="!form.branchdepartment" v-model="form.branchmunicipality" label="Ciudad" clearable clear-icon="mdi-close">
                    <template v-slot:no-data>
                      <div class="px-4">{{ noDataLabelCities }}</div>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="3" v-if="checkcountry">
                  <v-autocomplete outlined dense :items="getDistrictOptions(form.country, form.branchdepartment, form.branchmunicipality)" attach item-text="label" item-value="DistritoKey" :value-comparator="compareDistrictValue"
                    v-model="form.branchdistrict" label="Distrito" clearable clear-icon="mdi-close"
                    @change="syncLocationFromDistrict(form, 'country', 'branchdepartment', 'branchmunicipality', 'branchdistrict')"></v-autocomplete>
                </v-col>
                <!--v-col cols="12" md="3">
                  <v-autocomplete outlined dense item-text="Valores" attach item-value="Codigo" :items="establisment"
                    v-model="form.establishmenttype" label="Tipo establecimiento*" required
                    :rules="requiredRule"></v-autocomplete>
                </v-col-->
                <v-col cols="12" md="6">
                  <v-autocomplete outlined dense attach :items="['MEDIANO', 'PEQUEÑO', 'GRANDE']"
                    v-model="form.taxpayersize" label="TAMAÑO LEGAL DE CONTRIBUYENTE*" required
                    :rules="requiredRule"></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete outlined dense attach :items="tipoIngreso" item-text="Valores" item-value="Codigo"
                    v-model="form.tipoingresos" label="Tipo de Ingreso"></v-autocomplete>
                </v-col>
                <!--v-col cols="12" md="3">
                  <v-text-field outlined dense v-model="form.codestable" required :rules="requiredRule" :maxlength="4"
                    label="Codigo establecimiento* "></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field outlined dense v-model="form.codestablemh" required :rules="requiredRule" :maxlength="4"
                    label="Codigo establecimiento MH*"></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field outlined dense v-model="form.codpuntoventamh" required :rules="requiredRule"
                    :maxlength="4" label="Codigo punto venta MH*"></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field outlined dense v-model="form.codpuntoventa" required :rules="requiredRule" :maxlength="15"
                    label="Codigo punto venta*"></v-text-field>
                </v-col-->

              </v-row>

              <v-card class="my-3 business-settings-card" outlined>
                <div class="business-settings-header">
                  <div class="business-settings-title-row">
                    <v-btn icon small class="business-settings-title-action" @click="showPartnerBelongsTo = !showPartnerBelongsTo">
                      <v-icon>mdi-cog</v-icon>
                    </v-btn>
                    <h2 class="business-settings-title mb-4">
                      Configuraciones del negocio
                    </h2>
                  </div>
                </div>

                <v-row dense class="px-3 pb-3">
                  <v-col v-if="showPartnerBelongsTo" cols="12">
                    <v-text-field outlined dense v-model="form.partner_belongs_to" label="Pertenece a:"
                      placeholder="No agregue espacios"></v-text-field>
                  </v-col>
                  <v-col cols="12" class="settings-group-col">
                    <v-card class="settings-group-card" outlined>
                      <div class="settings-group-header">
                        <div class="settings-group-title">Restaurante y atención</div>
                        <div class="settings-group-subtitle">Opciones para negocios con mesas, propinas e impresión operativa.</div>
                      </div>
                      <div class="settings-group-body">
                        <v-row dense>
                          <v-col v-if="TipoPlan != 'Contabilidad'" cols="12" md="6">
                            <v-checkbox hide-details v-model="form.posrestaurant" :true-value="1" :false-value="0" label="POS Modo Restaurante" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col v-if="TipoPlan != 'Contabilidad'" cols="12" md="6">
                            <v-checkbox hide-details v-model="form.propinasdefault" :true-value="1" :false-value="0" :disabled="!form.posrestaurant" label="Activar por defecto las propinas" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col v-if="TipoPlan != 'Contabilidad'" cols="12" md="6">
                            <v-checkbox hide-details v-model="form.usenewposrestaurant" :true-value="1" :false-value="0" :disabled="!form.posrestaurant" label="Nuevo diseño de POS para restaurantes" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6" v-if="TipoPlan != 'Contabilidad'">
                            <v-checkbox hide-details v-model="form.useprinters" :true-value="1" :false-value="0" :disabled="!form.posrestaurant" label="Usar Impresoras" class="mt-0"></v-checkbox>
                          </v-col>
                        </v-row>
                      </div>
                    </v-card>
                  </v-col>

                  <v-col cols="12" class="settings-group-col">
                    <v-card class="settings-group-card" outlined>
                      <div class="settings-group-header">
                        <div class="settings-group-title">POS y facturación</div>
                        <div class="settings-group-subtitle">Comportamientos del punto de venta y reglas al facturar.</div>
                      </div>
                      <div class="settings-group-body">
                        <v-row dense>
                          <v-col cols="12" md="6" v-if="TipoPlan != 'Contabilidad'">
                            <v-checkbox hide-details v-model="form.pospayments" :true-value="1" :false-value="0" @change="handleChangePosPayments" label="POS Modo multipago" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6" v-if="TipoPlan != 'Contabilidad'">
                            <v-checkbox hide-details v-model="form.onlycreditpaymentmethod" :true-value="1" :false-value="0" label="Usar solamente la forma de pago 'Cuentas por pagar del receptor' en ventas a crédito" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6" v-if="TipoPlan != 'Contabilidad'">
                            <div class="d-flex align-center">
                              <v-checkbox
                                hide-details
                                v-model="form.pospaymentsenterbill"
                                :true-value="1"
                                :false-value="0"
                                :disabled="!form.pospayments"
                                label="Permitir facturar con Enter en formas de pago"
                                class="mt-0"
                              ></v-checkbox>
                              <v-tooltip bottom max-width="320">
                                <template #activator="{ on, attrs }">
                                  <v-btn
                                    icon
                                    class="ml-1"
                                    v-bind="attrs"
                                    v-on="on"
                                    aria-label="Información sobre facturar con Enter"
                                  >
                                    <v-icon small color="primary">mdi-information-outline</v-icon>
                                  </v-btn>
                                </template>
                                <span>
                                  Active esta opción solo si el teclado está en buen estado y el personal conoce el atajo. Un Enter involuntario puede crear la factura en el instante.
                                </span>
                              </v-tooltip>
                            </div>
                          </v-col>
                          <v-col v-if="TipoPlan != 'Ecoanual' && TipoPlan != 'Ecoanual CONAMYPE' && TipoPlan != 'Contabilidad'" cols="12" md="6">
                            <v-checkbox hide-details v-model="form.dynamicpricelists" :true-value="1" :false-value="0" label="Listas Dinámicas con Detalles de Facturas" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col v-if="TipoPlan != 'Ecoanual' && TipoPlan != 'Ecoanual CONAMYPE' && TipoPlan != 'Contabilidad'" cols="12" md="6">
                            <v-checkbox hide-details v-model="form.posrequiredidseller" :true-value="1" :false-value="0" label="Vendedor Requerido en Facturas" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col v-if="TipoPlan != 'Ecoanual' && TipoPlan != 'Ecoanual CONAMYPE' && TipoPlan != 'Contabilidad'" cols="12" md="6">
                            <v-checkbox hide-details v-model="form.posproductsalternativebehavior" :true-value="1" :false-value="0" label="POS Funcionamiento Alternativo para Cantidades" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col v-if="TipoPlan != 'Ecoanual' && TipoPlan != 'Ecoanual CONAMYPE' && TipoPlan != 'Contabilidad'" cols="12" md="6">
                            <v-checkbox hide-details v-model="form.posshowprincipalbarcode" :true-value="1" :false-value="0" label="Mostrar código alterno principal en POS" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6" v-if="TipoPlan != 'Contabilidad'">
                            <v-checkbox hide-details v-model="form.noaddivainpos" :true-value="1" :false-value="0" label="Agregar precios sin IVA en POS para Crédito Fiscales" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col v-if="TipoPlan != 'Ecoanual' && TipoPlan != 'Ecoanual CONAMYPE' && TipoPlan != 'Contabilidad'" cols="12" md="6">
                            <v-checkbox hide-details v-model="form.restivaposexentonosuj" :true-value="1" :false-value="0" label="Restar IVA en POS de Exentas y No Sujetas" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6" v-if="TipoPlan != 'Contabilidad' && TipoPlan != 'Ecoanual' && TipoPlan != 'Ecoanual CONAMYPE'">
                            <v-checkbox hide-details v-model="form.invoiceautosave" :true-value="1" :false-value="0" label="Autoguardado en POS" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6" v-if="TipoPlan != 'Contabilidad' && TipoPlan != 'Ecoanual CONAMYPE'">
                            <v-checkbox hide-details v-model="form.showunitcostinpos" :true-value="1" :false-value="0" label="Mostrar costo de productos en POS" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6" v-if="TipoPlan != 'Contabilidad'">
                            <v-checkbox hide-details v-model="form.dodnddncinhistoryinvoices" :true-value="1" :false-value="0" label="Permitir facturación de Notas de Crédito y Débito desde el Historial de facturas" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6" v-if="TipoPlan != 'Contabilidad'">
                            <v-checkbox hide-details v-model="form.includeexcludedsubjectcashclosing" :true-value="1" :false-value="0" label="Tomar en cuenta sujetos excluidos en el cierre de caja" class="mt-0"></v-checkbox>
                          </v-col>
                        </v-row>
                      </div>
                    </v-card>
                  </v-col>

                  <v-col cols="12" class="settings-group-col">
                    <v-card class="settings-group-card" outlined>
                      <div class="settings-group-header">
                        <div class="settings-group-title">Tickets e impresión</div>
                        <div class="settings-group-subtitle">Ajustes del formato de ticket y del flujo de impresión.</div>
                      </div>
                      <div class="settings-group-body">
                        <v-row dense>
                          <v-col cols="12" md="6" v-if="TipoPlan != 'Ecoanual' && TipoPlan != 'Ecoanual CONAMYPE' && TipoPlan != 'Contabilidad'">
                            <v-checkbox hide-details v-model="form.ticketformatfcf" :true-value="1" :false-value="0" label="Formato de Ticket para Consumidores Finales y Créditos fiscales" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6" v-if="TipoPlan != 'Ecoanual' && TipoPlan != 'Ecoanual CONAMYPE' && TipoPlan != 'Contabilidad'">
                            <v-checkbox hide-details v-model="form.ticketformat3nstar" :true-value="1" :false-value="0" :disabled="!form.ticketformatfcf" label="Formato especial tickets para impresoras 3Nstar" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6" v-if="TipoPlan != 'Contabilidad'">
                            <v-checkbox hide-details v-model="form.ticketdirectprinting" :true-value="1" :false-value="0" label="Impresión Directa de Ticket" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6" v-if="TipoPlan != 'Contabilidad'">
                            <v-checkbox hide-details v-model="form.ticketdirectnowinfcf" :true-value="1" :false-value="0" :disabled="!form.ticketdirectprinting" label="No mostrar ventana adicional de ticket en Consumidor Final" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6" v-if="TipoPlan != 'Contabilidad'">
                            <v-checkbox hide-details v-model="form.ticketdirectnowinccf" :true-value="1" :false-value="0" :disabled="!form.ticketdirectprinting" label="No mostrar ventana adicional de ticket en Crédito Fiscal" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6" v-if="TipoPlan != 'Contabilidad'">
                            <v-checkbox hide-details v-model="form.usecompactticket" :true-value="1" :false-value="0" :disabled="!form.ticketdirectprinting" label="Usar formato de ticket compacto" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6" v-if="TipoPlan != 'Contabilidad'">
                            <div class="d-flex align-center">
                              <v-checkbox hide-details v-model="form.usenormalticketv2" :true-value="1" :false-value="0" :disabled="!form.ticketformatfcf" label="Usar ticket normal V2" class="mt-0 flex-grow-1"></v-checkbox>
                              <v-text-field
                                :disabled="!normalizeCheckboxValue(form.usenormalticketv2)"
                                v-model="form.usenormalticketv2fontsize"
                                type="number"
                                min="5"
                                max="12"
                                step="0.1"
                                hide-details
                                dense
                                outlined
                                label="Tamaño de letra ticket normal V2 (pt)"
                                class="ml-3 mt-0 ticket-v2-font-size"
                              ></v-text-field>
                            </div>
                          </v-col>
                          <v-col cols="12" md="6" v-if="false && TipoPlan != 'Contabilidad' && form.usenormalticketv2">
                            <v-text-field
                              v-model="form.usenormalticketv2fontsize"
                              type="number"
                              min="5"
                              max="12"
                              step="0.1"
                              hide-details
                              dense
                              outlined
                              label="TamaÃ±o de letra ticket normal V2"
                              class="mt-0"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6" v-if="TipoPlan != 'Contabilidad' && TipoPlan != 'Ecoanual CONAMYPE'">
                            <v-checkbox hide-details v-model="form.showcorrelativecontrol" :true-value="1" :false-value="0" label="Mostrar correlativo de control interno" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6" v-if="TipoPlan != 'Contabilidad' && TipoPlan != 'Ecoanual CONAMYPE'">
                            <v-checkbox hide-details v-model="form.showcashinvoiceswhen1day" :true-value="1" :false-value="0" label="Mostrar facturas al contado cuando el plazo de crédito sea de 1 día." class="mt-0"></v-checkbox>
                          </v-col>
                        </v-row>
                      </div>
                    </v-card>
                  </v-col>

                  <v-col cols="12" class="settings-group-col" v-if="TipoPlan != 'Ecoanual CONAMYPE' && (RoleUser == 'ROLE_ROOT' || RoleUser == 'ROLE_ADMIN')">
                    <v-card class="settings-group-card" outlined>
                      <div class="settings-group-header">
                        <div class="settings-group-title">Compras</div>
                        <div class="settings-group-subtitle">Configuraciones para controlar el registro de compras y gastos.</div>
                      </div>
                      <div class="settings-group-body">
                        <v-row dense>
                          <v-col cols="12" md="6">
                            <v-checkbox hide-details v-model="form.blockpurchasesexpensesclosedperiods" :true-value="1" :false-value="0" label="Bloquear Compras y Gastos en períodos cerrados" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-checkbox hide-details v-model="form.allowpurchasesexpensesonlyopenperiods" :true-value="1" :false-value="0" label="Permitir Compras y Gastos únicamente en períodos abiertos" class="mt-0"></v-checkbox>
                          </v-col>
                        </v-row>
                      </div>
                    </v-card>
                  </v-col>

                  <v-col cols="12" class="settings-group-col" v-if="TipoPlan != 'Ecoanual CONAMYPE'">
                    <v-card class="settings-group-card" outlined>
                      <div class="settings-group-header">
                        <div class="settings-group-title">Inventario y operación</div>
                        <div class="settings-group-subtitle">Controles que impactan existencias, lotes, almacenes y entregas.</div>
                      </div>
                      <div class="settings-group-body">
                        <v-row dense>
                          <v-col v-if="TipoPlan != 'Ecoanual' && TipoPlan != 'Ecoanual CONAMYPE' && TipoPlan != 'Contabilidad'" cols="12" md="6">
                            <v-checkbox hide-details v-model="form.enablenegativeitem" :true-value="1" :false-value="0" label="Permitir cantidades negativas de articulos" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6" v-if="TipoPlan != 'Contabilidad'">
                            <v-checkbox hide-details v-model="form.showbatchinfopos" :true-value="1" :false-value="0" label="Mostrar lote y fecha de expiración en facturas" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6" v-if="TipoPlan != 'Contabilidad'">
                            <v-checkbox hide-details v-model="form.usereservewarehouse" :true-value="1" :false-value="0" label="Utilizar almacén de reserva para facturas sin procesar en POS" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6" v-if="TipoPlan != 'Contabilidad'">
                            <v-checkbox hide-details v-model="form.billposwith1warehouse" :true-value="1" :false-value="0" label="Solo permitir facturar productos del mismo almacén en una misma factura" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6" v-if="TipoPlan != 'Contabilidad'">
                            <v-checkbox hide-details v-model="form.addwarehouseofprodinbill" :true-value="1" :false-value="0" label="Agregar almacén de origen del producto en detalles de la factura" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6" v-if="TipoPlan != 'Contabilidad'">
                            <v-checkbox hide-details v-model="form.deliverycontrol" :true-value="1" :false-value="0" label="Control de entregas de productos" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6" v-if="TipoPlan != 'Contabilidad'">
                            <v-checkbox hide-details v-model="form.requireexpirationdateinventorypurchases" :true-value="1" :false-value="0" label="Requerir fecha de vencimiento en todas las compras de inventarios" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6" v-if="TipoPlan != 'Contabilidad'">
                            <v-checkbox hide-details v-model="form.usetechnical" :true-value="1" :false-value="0" label="Requerir técnico en comprobantes" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6" v-if="TipoPlan != 'Contabilidad'">
                            <v-checkbox hide-details v-model="form.nomergeprodwithprovs" :true-value="1" :false-value="0" label="No relacionar productos con proveedores" class="mt-0"></v-checkbox>
                          </v-col>
                        </v-row>
                      </div>
                    </v-card>
                  </v-col>

                  <v-col cols="12" class="settings-group-col" v-if="TipoPlan != 'Ecoanual CONAMYPE'">
                    <v-card class="settings-group-card" outlined>
                      <div class="settings-group-header">
                        <div class="settings-group-title">Reglas y giros especiales</div>
                        <div class="settings-group-subtitle">Configuraciones fiscales, restricciones operativas y comportamientos según el tipo de negocio.</div>
                      </div>
                      <div class="settings-group-body">
                        <v-row dense>
                          <v-col v-if="TipoPlan != 'Ecoanual' && TipoPlan != 'Ecoanual CONAMYPE' && TipoPlan != 'Contabilidad'" cols="12" md="6">
                            <v-checkbox hide-details v-model="form.isexempt" :true-value="1" :false-value="0" label="Exento" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col v-if="TipoPlan != 'Ecoanual' && TipoPlan != 'Ecoanual CONAMYPE' && TipoPlan != 'Contabilidad'" cols="12" md="6">
                            <v-checkbox hide-details @change="handleChangeZoneConfiguration('client')" v-model="form.enablezoneconfiguration" :true-value="1" :false-value="0" label="Configuración de Zonas para Clientes" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col v-if="TipoPlan != 'Ecoanual' && TipoPlan != 'Ecoanual CONAMYPE' && TipoPlan != 'Contabilidad'" cols="12" md="6">
                            <v-checkbox hide-details @change="handleChangeZoneConfiguration('seller')" v-model="form.enablesellerzoneconfiguration" :true-value="1" :false-value="0" label="Configuración de Zonas para Vendedores" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-checkbox hide-details v-model="form.nosaveunadjusteditems" :true-value="1" :false-value="0" label="No permitir guardar partidas descuadradas" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-checkbox hide-details v-model="form.notclearaccount" :true-value="1" :false-value="0" label="No borrar concepto y montos al editar partidas" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-checkbox hide-details v-model="form.usesugestaccount" :true-value="1" :false-value="0" label="Usar sugerencias de cuentas contables" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-checkbox hide-details v-model="form.detailedaccountingentries" :true-value="1" :false-value="0" label="Impresión de partidas contables de forma detallada" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col v-if="TipoPlan != 'Ecoanual' && TipoPlan != 'Ecoanual CONAMYPE' && TipoPlan != 'Contabilidad'" cols="12" md="6">
                            <v-checkbox hide-details v-model="form.legalagentretain" :true-value="1" :false-value="0" label="Es agente de retención 1%" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col v-if="TipoPlan != 'Ecoanual' && TipoPlan != 'Ecoanual CONAMYPE' && TipoPlan != 'Contabilidad'" cols="12" md="6">
                            <v-checkbox hide-details v-model="form.isoptical" :true-value="1" :false-value="0" label="Es óptica" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6" v-if="TipoPlan != 'Contabilidad'">
                            <v-checkbox hide-details v-model="form.ishosting" :true-value="1" :false-value="0" label="Es Hospedaje" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6" v-if="TipoPlan != 'Contabilidad'">
                            <v-checkbox hide-details v-model="form.keepturismtaxunitprice" :true-value="1" :false-value="0" :disabled="!form.ishosting" label="Mantener activo siempre el impuesto al turismo en precios unitarios" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6" v-if="TipoPlan != 'Contabilidad'">
                            <v-checkbox hide-details v-model="form.showformairlinetickets" :true-value="1" :false-value="0" label="Mostrar formulario de boletos de vuelo" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6" v-if="TipoPlan != 'Contabilidad'">
                            <v-checkbox hide-details v-model="form.userecurringtemplates" :true-value="1" :false-value="0" label="Utilizar plantillas de cobros recurrentes" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-checkbox hide-details v-if="$store.state.bussinessType === 'veterinary'" v-model="form.veterinarypatienttabsautosave" :true-value="1" :false-value="0" label="Activar autoguardado en veterinaria (Historial y Examenes)" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-checkbox hide-details v-if="$store.state.bussinessType === 'veterinary'" v-model="form.enableviewdoctorpet" :true-value="1" :false-value="0" label="Historial clinico vista DoctorPet" class="mt-0"></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-checkbox hide-details v-if="$store.state.bussinessType === 'veterinary' && TipoPlan != 'Ecoanual' && TipoPlan != 'Ecoanual CONAMYPE'" v-model="form.useclinicalreport" :true-value="1" :false-value="0" label="Usar reporte de análisis clinico" class="mt-0"></v-checkbox>
                          </v-col>
                        </v-row>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <alerts v-if="alert.show" v-on:close_alert="closeAlert" v-on:accept_alert="acceptAlert" :properties="alert">
    </alerts>
  </div>
</template>

<script>
import Vue from 'vue'
import Alerts from '@/components/Alerts'
import { mapGetters } from 'vuex'
import Vuex from '../../../../store';
import locationDistrictMixin from "../../../../mixins/locationDistrict";
import {  nitMaskHandlingHomologation, nrc as nrcMask,numberSV, applyNitMaskHandlingHomologationOutOfInput, applyDUIMaskOutOfInput } from "@/helpers/masks";
import { validateNITHomologation } from '../../../../helpers/object'

export default {
  name: "ManageBusiness",
  props: ['business', 'win'],
  components: {
    Alerts
  },
  mixins: [locationDistrictMixin],
  data: () => ({
    currencies: [],
    alert: {
      type: "success",
      show: false,
      header: "",
      body: "",
    },
    valid: false,
    url: null,
    image: null,

    //departments: ['San salvador','Santa Ana', 'Soyapango'],
    //municipalities: ['San salvador','Santa Ana', 'Soyapango','San Miguel'],
    /* activities: [
      {
        Codigo: '01131',
        Valores: 'AGSP-PAPCASC : Cultivo de raíces y tubérculos',
      },
      {
        Codigo: '01191',
        Valores: 'AGSP-PAPCASC : Cultivo de plantas no perennes para la producción de semillas y flores',
      },
      {
        Codigo: '01619',
        Valores: 'AGSP-PAPCASC : Servicios agrícolas ncp'
      },
      {
        Codigo: '62020',
        Valores: 'IC-PICIAC : Consultorías y gestión de servicios informáticos'
      }
    ], */
    /*    establisment: [
         {
           Codigo: '01',
           Valores: 'Sucursal / Agencia',
         },
         {
           Codigo: '02',
           Valores: 'Casa matriz',
         }
       ], */
    form: {
      usenormalticketv2: 0,
      usenormalticketv2fontsize: "7.5",
      ticketformatfcf: 0,
    },
    RoleUser: JSON.parse(localStorage.getItem("user")).roles[0],
    businessTypes: [
      {
        name: 'Veterinary',
        value: 'veterinary',
      },
      {
        name: 'Laboratory',
        value: 'bloodtestlaboratory',
      },
      {
        name: 'Bill',
        value: 'accounting_and_bill',
      },
      {
        name: 'Medical Clinic',
        value: 'medicalclinic',
      }
    
    ],
    requiredRule: [
      value => !!value || 'El dato es requerido.',
    ],
    stateList: [],
    cityList: [],
    noDataLabelStates: 'Seleccione un país',     
    noDataLabelCities: 'No hay ciudades disponibles',
    validImageSize: true,
    TipoPlan: JSON.parse(localStorage.getItem("user")).TipoPlan,
    PreferentialPlan: JSON.parse(localStorage.getItem("user")).preferentialplan,
    showPartnerBelongsTo: false,
  }),
  computed: {
    ...mapGetters(['getCatalogMH']),
    departments() {

      return this.getCatalogMH('Departamento')
    },
    municipalities() {
      const municipalities = this.getCatalogMH('Municipio')
      if (this.form.branchdepartment) {

        const department = municipalities.filter(mun => mun.Departamento == this.form.branchdepartment)

        return department
      }
      return []
    },
    hideTicketFormatFCF(){
      return ( this.TipoPlan === 'Emprendedor' && this.PreferentialPlan === 0 ) ||  ( this.TipoPlan === 'Ecoanual' && this.PreferentialPlan === 0 )
    },
    establisment() {
      return this.getCatalogMH('TipoEstablecimiento')
    },
    activities() {
      return this.getCatalogMH('ActividadEconomica')
    },
    countryList() {
      return this.$store.getters.getCountries;
    },
    checkcountry() {
      if (this.form.country == 'El Salvador') return true
      else return false
    },
    getcurrency() {
      const countries = this.$store.getters.getCountries;
      const currencies = countries.map(country => {
        return {
          name: country.currency_name,
          value: country.currency_symbol,
          currentcountry: country.name
        }
      })

      return currencies
    },
    tipoIngreso() {
      return this.getCatalogMH('TipoIngreso')
    }

  },
  watch: {
    business: {
      immediate: true,
      handler(newBusiness) {
        if (!newBusiness) return;
        this.initializeBusinessForm(newBusiness);
      }
    },
    "form.taxpayersize"() {
      if(this.form.taxpayersize == "GRANDE") {
        this.form.legalagentretain = true
      }
      else {
        if (!this.business || !this.business.LegalAgentRetain) {
          this.form.legalagentretain = false
        }
      }
    },
    'form.posrestaurant': {
      deep:true,
      immediate:true,
      handler(newVal){
        if(!newVal){
          this.form.propinasdefault = 0;
          this.form.usenewposrestaurant = 0;
          this.form.useprinters = 0;
        }
      }
    },
    'form.ticketformatfcf': {
      deep:true,
      immediate:true,
      handler(newVal){
        if(!newVal){
          this.form.ticketformat3nstar = 0;
          this.form.usenormalticketv2 = 0;
          this.form.usenormalticketv2fontsize = "7.5";
        }
      }
    },
    'form.usenormalticketv2': {
      deep:true,
      immediate:true,
      handler(newVal){
        if(!newVal){
          this.form.usenormalticketv2fontsize = "7.5";
        }
        else {
          this.form.usecompactticket = 0;
          if(!this.form.usenormalticketv2fontsize){
            this.form.usenormalticketv2fontsize = "7.5";
          }
        }
      }
    },
    'form.usecompactticket': {
      deep:true,
      immediate:true,
      handler(newVal){
        if(newVal){
          this.form.usenormalticketv2 = 0;
          this.form.usenormalticketv2fontsize = "7.5";
        }
      }
    },
    'form.ticketdirectprinting': {
      deep:true,
      immediate:true,
      handler(newVal){
        if(!newVal){
          this.form.ticketdirectnowinfcf = 0;
          this.form.ticketdirectnowinccf = 0;
          this.form.usecompactticket = 0;
        }
      }
    },
    'form.ishosting': {
      deep:true,
      immediate:true,
      handler(newVal){
        if(!newVal){
          this.form.keepturismtaxunitprice = 0;
        }
      }
    }
  },
  async mounted() {
  },
  methods: {
    normalizeCheckboxValue(value) {
      return value === 1 || value === '1' || value === true ? 1 : 0;
    },
    normalizeBusinessCheckboxes() {
      const checkboxFields = [
        'posrestaurant',
        'propinasdefault',
        'usenewposrestaurant',
        'useprinters',
        'pospayments',
        'pospaymentsenterbill',
        'onlycreditpaymentmethod',
        'ticketformatfcf',
        'ticketformat3nstar',
        'dynamicpricelists',
        'posrequiredidseller',
        'posproductsalternativebehavior',
        'posshowprincipalbarcode',
        'isexempt',
        'enablezoneconfiguration',
        'enablesellerzoneconfiguration',
        'enablenegativeitem',
        'enableviewdoctorpet',
        'legalagentretain',
        'restivaposexentonosuj',
        'isoptical',
        'showbatchinfopos',
        'noaddivainpos',
        'nosaveunadjusteditems',
        'usereservewarehouse',
        'ishosting',
        'keepturismtaxunitprice',
        'showcorrelativecontrol',
        'ticketdirectprinting',
        'ticketdirectnowinfcf',
        'ticketdirectnowinccf',
        'invoiceautosave',
        'billposwith1warehouse',
        'addwarehouseofprodinbill',
        'deliverycontrol',
        'requireexpirationdateinventorypurchases',
        'showunitcostinpos',
        'usetechnical',
        'showformairlinetickets',
        'userecurringtemplates',
        'useclinicalreport',
        'usecompactticket',
        'usenormalticketv2',
        'veterinarypatienttabsautosave',
        'notclearaccount',
        'usesugestaccount',
        'detailedaccountingentries',
        'nomergeprodwithprovs',
        'dodnddncinhistoryinvoices',
        'includeexcludedsubjectcashclosing',
        'blockpurchasesexpensesclosedperiods',
        'allowpurchasesexpensesonlyopenperiods'
      ];

      checkboxFields.forEach((field) => {
        Vue.set(this.form, field, this.normalizeCheckboxValue(this.form[field]));
      });
    },
    normalizeNormalTicketV2FontSize() {
      const parsed = parseFloat(this.form.usenormalticketv2fontsize);

      if (Number.isNaN(parsed)) {
        this.form.usenormalticketv2fontsize = "7.5";
        return;
      }

      const clamped = Math.min(12, Math.max(5, parsed));
      this.form.usenormalticketv2fontsize = clamped.toFixed(1);
    },
    initializeBusinessForm(business) {
      Object.keys(business).forEach(key => {
        const normalizedKey = key.replace('Business', '').toLowerCase();
        Vue.set(this.form, normalizedKey, business[key]);
      });

      this.normalizeBusinessCheckboxes();
      this.form.usenormalticketv2fontsize = this.form.usenormalticketv2fontsize || "7.5";
      this.normalizeNormalTicketV2FontSize();

      this.form.billingnrc && (this.form.billingnrc = applyDUIMaskOutOfInput(this.form.billingnrc));
      this.form.billingnit && (this.form.billingnit = applyNitMaskHandlingHomologationOutOfInput(this.form.billingnit));

      if(this.form.country != 'El Salvador'){
        this.getStates();
        this.getCities();
      }

      this.getProfileImage();
    },
    async getProfileImage() {
      if(!this.business.BusinessLogoPath) return
      //const { imageBase64: logoImageBase64 } = await this.$API.utilities.getImageInBase64({ "file": this.business.BusinessLogoPath })  
      this.url = this.business.BusinessLogoPath;
    },
    async getStates(){
      if(this.form.country == 'El Salvador') return [];
      if(this.form.country){
        this.noDataLabelStates = 'Cargando...'
        this.stateList = []
        
        this.stateList = await this.$API.general.getStates(this.form.country)

        this.noDataLabelStates = 'No hay Estados disponibles';
      }
    },
    async getCities(){
      if(this.form.country == 'El Salvador') return [];
      console.log(this.form.branchdepartment);
      if(this.form.branchdepartment){
        this.noDataLabelCities = 'Cargando...'
        this.cityList = []
        
        this.cityList = await this.$API.general.getCities(this.form.branchdepartment);
        this.noDataLabelCities = 'No hay Ciudades disponibles';
        return this.cityList;
      }

      this.cityList = [];
      this.form.branchmunicipality = null;
      this.noDataLabelCities = 'No hay Ciudades disponibles';
      return [];
    },
    async onCountryChange() {
      this.form.branchdepartment = null;
      this.form.branchmunicipality = null;
      this.form.branchdistrict = null;
      await this.getcurrencybyCountry();
      await this.getStates();
    },
    async maskNRC(e) { 
      if(e.which === 8) return false;
      if(this.form.billingnrc) {
        this.form.billingnrc?.length > 1 && (this.form.billingnrc = await nrcMask(this, this.form.billingnrc));
      }
    },
    async maskNit(e) {
      if(e.which === 8) return false;
      if(this.form.billingnit){
        this.form.billingnit = await nitMaskHandlingHomologation(this, this.form.billingnit);
      }
    },
    async maskNum() {
      if(this.form.phone && this.form.country == 'El Salvador' ){
        this.form.phone = await numberSV(this, this.form.phone);
      } 
      if(this.form.cellphone && this.form.country == 'El Salvador'){
        this.form.cellphone = await numberSV(this, this.form.cellphone);
      }
      if(this.form.whatsapp && this.form.country == 'El Salvador'){
        this.form.whatsapp = await numberSV(this, this.form.whatsapp);
      }

    },
    logout() {
      const confKeys = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith("conf_")) {
          confKeys.push({
            key,
            value: localStorage.getItem(key),
          });
        }
      }
      // this.delete_cookie('details')
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("customizeOptions");
      localStorage.removeItem("branch");

      Vuex.commit("setToken", null);
      Vuex.commit("setUser", null);
      Vuex.commit("setCustomizeOptions", null);
      Vuex.commit("RESTART_STATE", null);
      localStorage.clear();
      confKeys.forEach(({ key, value }) => {
        localStorage.setItem(key, value);
      });
      this.$router.push("/login");
    },

    getcurrencybyCountry() {

      this.countryList.forEach(country => {
        if (country.name == this.form.country) {
          this.form.currency = country.currency_symbol
        }
      })

    },
    asignDescription() {
      this.activities.forEach(element => {
        if (element.Codigo == this.form.codactividad) {
          this.form.descactividad = element.Valores
        }
      });
    },
    closeAlert() {
      this.alert.show = false;
      if (this.alert.options == "reload") {
        this.$store.dispatch('reloadData', 'business')
      }
    },
    acceptAlert() {
      this.alert.show = false;
      if (this.alert.options == "Deletebussiness") {
        this.deleteBusiness();
      }
      else if (this.alert.options == "reload") {
        this.$store.dispatch('reloadData', 'business')
      }
      else if (this.alert.options == "newWindow") {
        this.$store.dispatch('deleteWindowByUuid', { uuid: this.win.uuid });
        this.$store.dispatch('reloadData', 'business')
      }
      if (this.alert.options == "closeSesion") {
        this.logout();
      }
    },
    showAlert(type, header, body, options = null) {
      type = type == null ? "danger" : type;
      this.alert.type = type;
      this.alert.header = header;
      this.alert.body = body;
      this.alert.show = true;
      this.alert.options = options != null ? options : null;
    },
    confirmDelete() {
      this.showAlert("question", "Confirmación", "¿Está seguro de eliminar el negocio?", "Deletebussiness");
    },
    Preview_image() {
      this.url = URL.createObjectURL(this.image)
    },
    addBusiness() {
      if (this.checkImageSize()) return;

      if (!this.valid) { this.showAlert("warning", "Error", "Debe completar los campos requeridos"); return; }

      if( !validateNITHomologation( 'form', this, 'billingnit', 'Número de NIT' ) ) {
        return;
      }

      if (this.RoleUser != 'ROLE_ROOT')
        this.form.type = JSON.parse(localStorage.getItem("user")).businessType;

      this.asignDescription();
      let formdata = new FormData();
      this.form.billingnit = this.form.billingnit.replace(/-/g, '');
      this.form.billingnrc = this.form.billingnrc?.replace(/-/g, '');
      formdata.append('logofile', this.image);
      formdata.append('business', JSON.stringify(this.form));
      this.$API.business.addBusiness(formdata)
        .then(() => {
          this.showAlert(
            "success",
            "Ingreso correcto",
            "Negocio registrado correctamente",
          );
          this.$store.dispatch('reloadData', 'business');
          //this.$store.dispatch('addWindow',{'name':'BusinessList',component:'BusinessList',unique:false})

        })
    },
    updateBusiness() {
      if (this.checkImageSize()) return;

      if (!this.valid) { this.showAlert("warning", "Error", "Debe completar los campos requeridos"); return; }

      if( !validateNITHomologation( 'form', this, 'billingnit', 'Número de NIT' ) ) {
        return;
      }

      this.asignDescription();
      this.normalizeNormalTicketV2FontSize();
      let formdata = new FormData();
      this.form.billingnit = this.form.billingnit.replace(/-/g, '');
      this.form.billingnrc = this.form.billingnrc?.replace(/-/g, '');
      if (this.image) formdata.append('logofile', this.image);
      formdata.append('business', JSON.stringify(this.form));

      this.$API.business.updateBusiness(formdata, this.business.ID_Business)
        .then(() => {
          this.showAlert("closeeSesion", "exito ", "Se han modificado datos al negocio.Para que los cambios surtan efecto debe cerrar sesion", 'closeSesion');


          //this.$store.dispatch('addWindow',{'name':'BusinessList',component:'BusinessList',unique:false})

        })
        .catch(() => {
          this.showAlert("danger", "Error", "Error al actualizar los datos", "reload");
        })
    },
    deleteBusiness() {
      this.$API.business.deleteBusiness(this.business.ID_Business)
        .then(() => {
          this.showAlert("success", "Success", "Negocio eliminado correctamente", "newWindow");

        })
        .catch(() => {
          this.showAlert("danger", "Error", "Error al eliminar el negocio", "reload");
        })
    },
    maxFileSize(event) {
      const allowedSize = 2 * 1024 * 1024; // 2 MB in bytes
      const fileSize = event?.size || null;

      if (fileSize > allowedSize) {
        this.validImageSize = false;
        return `El tamaño del archivo debe ser menor a 2 Mb`;
      }

      this.validImageSize = true;
      return true;
    },
    checkImageSize() {
      if (this.validImageSize == false) {
        this.showAlert("danger", "Error", "El tamaño de la imagen debe ser menor a 2 Mb");
        return true;
      }
      return false;
    },
    handleChangeZoneConfiguration(type){
      if(type === 'client' && this.form.enablezoneconfiguration ){
        this.form.enablesellerzoneconfiguration = 0
      }

      if(type === 'seller' && this.form.enablesellerzoneconfiguration ){
        this.form.enablezoneconfiguration = 0
      }
    },
    handleChangePosPayments() {
      if (!this.form.pospayments) {
        this.form.pospaymentsenterbill = 0;
      }
    }
  }
}
</script>

<style scoped>
.ticket-v2-font-size {
  width: 210px;
}

.btndelete {
  background-color: #E3191E !important;
  color: white;
}

.btnsave {
  background-color: #00A178 !important;
  color: white;
}

.tabs:hover {
  background-color: rgba(80, 80, 80, 1);
  cursor: pointer;
}

.tabs {
  width: 100%;
  padding: 10px;
  background-color: rgba(60, 60, 60, 1);
  color: white !important;
  border-style: solid;
  border-color: black;
  border-width: 1px;
  border-radius: 10px;

}

.tabsNh {
  width: 100%;
  padding: 10px;
  background-color: rgba(60, 60, 60, 1);
  color: white !important;
  border-style: solid;
  border-color: black;
  border-width: 1px;
  border-radius: 10px;

}

.tabsB {
  width: 100%;
  padding: 10px;
  background-color: #1976d2;
  color: white;
  border-radius: 15px;
  border-style: solid;
  border-color: black;
  border-width: 1px;
}

.tabsB:hover {
  background-color: #0d47a1;
  cursor: pointer;
}

.business-settings-card {
  border-radius: 18px;
  border-color: #d7dee7 !important;
  background: #ffffff;
}

.business-settings-header {
  padding: 20px 20px 8px;
}

.business-settings-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.business-settings-title-action {
  margin-bottom: 16px;
}

.business-settings-title {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 700;
  color: #1f2937;
}

.business-settings-subtitle {
  margin-top: 6px;
  max-width: 780px;
  color: #5f6c7b;
  font-size: 0.95rem;
  line-height: 1.5;
}

.settings-group-card {
  height: 100%;
  border-radius: 14px;
  border-color: #dce4ed !important;
  box-shadow: none !important;
  background-color: #ffffff;
}

.settings-group-col {
  margin-bottom: 16px;
}

.settings-group-header {
  padding: 16px 18px 10px;
  border-bottom: 1px solid #eef2f6;
}

.settings-group-title {
  font-size: 1rem;
  font-weight: 700;
  color: #223042;
}

.settings-group-subtitle {
  margin-top: 4px;
  color: #6b7788;
  font-size: 0.88rem;
  line-height: 1.45;
}

.settings-group-body {
  padding: 10px 18px 14px;
}

.settings-group-body .v-input--checkbox {
  margin-top: 0 !important;
}

.settings-group-body ::v-deep .v-input--is-disabled {
  opacity: 1 !important;
}

.settings-group-body ::v-deep .v-input--is-disabled .v-label {
  color: #9ca3af !important;
}

.settings-group-body ::v-deep .v-input--is-disabled .v-icon {
  color: #b6bcc6 !important;
}

.settings-group-body ::v-deep .v-input--is-disabled .v-input--selection-controls__input {
  opacity: 0.7 !important;
}
</style>
